var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bags-price-checker-header" }, [
      _c("span", [_vm._v("BAG PRICE CHECKER")]),
      _vm._v(" "),
      _c("span", { staticClass: "sub" }, [_vm._v("*Required Fields")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a08e72e0", { render: render, staticRenderFns: staticRenderFns })
  }
}